// ticketingSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { viewTickets, getIssues, createTicket } from "../config";

// Get tickets list
export const getTicketsList = createAsyncThunk(
  "ticketing/getTicketsList",
  async ({ user_id }) => {
    const response = await axios.get(`${viewTickets}/${user_id}`);
    console.log(response);
    return response.data || response.data?.data;
  }
);

// Get issues
export const getIssuesList = createAsyncThunk(
  "ticketing/getIssuesList",
  async () => {
    const res = await axios.get(getIssues);
    return res?.data?.map((i) => ({
      id: i.id,
      label: i.issue,
      parent_id: i.parent_issue_id,
    }));
  }
);

// Create ticket
export const createTicketThunk = createAsyncThunk(
  "ticketing/createTicket",
  async ({ userData, lastId, issue_description, files }, { dispatch }) => {
    const formData = new FormData();
    formData.append(
      "ticketData",
      JSON.stringify({
        user_id: userData?.admin_id,
        issue_id: lastId,
        description: issue_description,
        email: userData?.email,
      })
    );
    files.forEach((f) => formData.append("files", f));

    const res = await fetch(createTicket, { method: "POST", body: formData });
    const json = await res.json();

    await dispatch(getTicketsList({ user_id: userData?.id }));
    return json;
  }
);

const ticketSlice = createSlice({
  name: "ticketsMgt",
  initialState: {
    ticketsList: null,
    issues: [],
    data: {
      list: { initial_list: [] },
      selected_values: {},
      files: [],
      issue_description: "",
      loader: false,
    },
    error: "",
    countDetailsStatus: "idle",
    countDetailsError: null,
    ticketsListStatus: "idle",
    ticketsListError: null,
    issuesStatus: "idle",
    issuesError: null,
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    updateData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    updateList: (state, action) => {
      const { parentId, key } = action.payload;
      const filtered = state.issues.filter(
        (i) =>
          (parentId == null && i.parent_id == null) || i.parent_id === parentId
      );
      state.data.list[key] = filtered;
    },
    handleInputChangeRedux: (state, action) => {
      const { option, key, listKey } = action.payload;
      const selected = { ...state.data.selected_values };
      Object.keys(selected)
        .filter((k) => k > key)
        .forEach((k) => delete selected[k]);

      const newList = Object.fromEntries(
        Object.entries(state.data.list).filter(
          ([k]) => !Object.keys(selected).includes(k)
        )
      );

      state.data.selected_values = { ...selected, [key]: option };
      state.data.list = newList;

      if (option) {
        const filtered = state.issues.filter(
          (i) =>
            (option.id == null && i.parent_id == null) ||
            i.parent_id === option.id
        );
        state.data.list[listKey] = filtered;
      }
    },
    addFiles: (state, action) => {
      state.data.files = [...state.data.files, ...action.payload];
    },
    removeFile: (state, action) => {
      state.data.files.splice(action.payload, 1);
    },

    // ✅ NEW resetData reducer
    resetData: (state) => {
      state.data = {
        list: { initial_list: state.issues.filter((i) => i.parent_id == null) },
        selected_values: {},
        files: [],
        issue_description: "",
        loader: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTicketsList.pending, (state) => {
        state.ticketsListStatus = "loading";
      })
      .addCase(getTicketsList.fulfilled, (state, action) => {
        state.ticketsListStatus = "succeeded";
        state.ticketsList = action.payload;
      })
      .addCase(getTicketsList.rejected, (state, action) => {
        state.ticketsListStatus = "failed";
        state.ticketsListError =
          action.payload || action.error?.message || null;
      })
      .addCase(getIssuesList.pending, (state) => {
        state.issuesStatus = "loading";
      })
      .addCase(getIssuesList.fulfilled, (state, action) => {
        state.issuesStatus = "succeeded";
        state.issues = action.payload;
        state.data.list.initial_list = action.payload.filter(
          (i) => i.parent_id == null
        );
      })
      .addCase(getIssuesList.rejected, (state, action) => {
        state.issuesStatus = "failed";
        state.issuesError = action.error?.message;
      })
      .addCase(createTicketThunk.pending, (state) => {
        state.data.loader = true;
      })
      .addCase(createTicketThunk.fulfilled, (state) => {
        state.data.loader = false;
      })
      .addCase(createTicketThunk.rejected, (state) => {
        state.data.loader = false;
      });
  },
});

export const {
  setError,
  updateData,
  updateList,
  handleInputChangeRedux,
  addFiles,
  removeFile,
  resetData,
} = ticketSlice.actions;
export default ticketSlice.reducer;
